import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useUserPermissions } from "../SignIn/UserPermissionsContext";
import DepartmentPage from "./DepartmentPage";
import { getDepartmentConfig } from "./utils/departmentConfig";

const DepartmentRouterPage = () => {
  const { departmentKey } = useParams();
  const { userPermissions = [] } = useUserPermissions();

  const configMap = getDepartmentConfig(userPermissions);
  const config = configMap[departmentKey];

  if (!config || !config.show) {
    return <Navigate to="/Department/AllStaff" replace />;
  }

  return <DepartmentPage title={config.title} cards={config.cards || []} />;
};



export default DepartmentRouterPage;
